module.exports = __webpack_public_path__ + "img/voice-thumb15.725e7ac.jpg";